import React, { useContext, useEffect, useState } from 'react'
import Layout from '../../Component/layout/main-layout'
import { GetLawsTable } from '../../api/Queries/get'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next';
import Loading from '../../Component/loader/loader'
import { Context } from '../../Store/context';
import layoutBgImg from '../../Images/layout/laws.png'

const LawsTable = () => {
    const location = useLocation().pathname.split('/')[2];
    const [laws, setLaws] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const { i18n, t } = useTranslation();
    const { showError } = useContext(Context);

    useEffect(() => {
        setIsLoading(true)
        const getLaws = async () => {
            try {
                const res = await GetLawsTable(location)
                setIsLoading(false)
                setLaws(res.data)
            } catch (error) {
                showError(error.message);
                setIsLoading(false)
            }
        }
        getLaws()
    }, [location, showError])

    const getLawPdf = (laws) => {
        const currentLang = i18n.language;
        if (currentLang === 'ru') {
            return laws.rus_pdf;
        } else if (currentLang === 'en') {
            return laws.eng_pdf;
        }
        return laws.tm_pdf;
    };

    const pdf = getLawPdf(laws)

    return (
        <div className='mb-20'>
            <Layout
                title={t('laws_codes')}
                page={t('tm_laws')}
                layoutBgImg={layoutBgImg}
            />
            <main className='media'>
                <div className='bg-white mt-8 border border-secondary 
                                p-8 w-full dark:border-dark-border 
                                dark:bg-dark-box dark:text-dark-text'>
                    {isLoading ? <Loading /> :
                        <div className='h-[1000px] max-h-max'>
                            <iframe
                                src={`${pdf}#toolbar=0&navpanes=0&view=FitH`}
                                className="w-full h-full"
                                frameBorder="0"
                                title="PDF Viewer"
                            ></iframe>
                        </div>
                    }
                </div>
            </main>
        </div>
    )
}

export default LawsTable




// import React, { useContext, useEffect, useState } from 'react'
// import Layout from '../../Component/layout/main-layout'
// import { GetLawsTable } from '../../api/Queries/get'
// import { useLocation } from 'react-router-dom'
// import { useTranslation } from 'react-i18next';
// import Loading from '../../Component/loader/loader'
// import { Context } from '../../Store/context';
// import layoutBgImg from '../../Images/layout/laws.JPG'

// const LawsTable = () => {
//     const location = useLocation().pathname.split('/')[2];
//     const [laws, setLaws] = useState([])
//     const [isLoading, setIsLoading] = useState(false)
//     const { i18n, t } = useTranslation();
//     const { showError } = useContext(Context);

//     useEffect(() => {
//         setIsLoading(true)
//         const getLaws = async () => {
//             try {
//                 const res = await GetLawsTable(location)
//                 setIsLoading(false)
//                 setLaws(res.data)
//             } catch (error) {
//                 showError(error.message);
//                 setIsLoading(false)
//             }
//         }
//         getLaws()
//     }, [location, showError])

//     const getLawPdf = (laws) => {
//         const currentLang = i18n.language;
//         if (currentLang === 'ru') {
//             return laws.rus_pdf;
//         } else if (currentLang === 'en') {
//             return laws.eng_pdf;
//         }
//         return laws.tm_pdf;
//     };

//     const pdf = getLawPdf(laws)

//     return (
//         <div className='mb-20'>
//             <Layout
//                 title={t('laws_codes')}
//                 page={t('tm_laws')}
//                 layoutBgImg={layoutBgImg}
//             />
//             <main className='px-4 xxl:px-12 xxxl:px-32 xxxxl:px-64 
//                              xxxxxl:px-[400px] xxxxxxl:px-[650px]  
//                              xxxxxxxl:px-[1600px] xxxxxxxxl:px-[2400px]'>
//                 <div className='bg-white mt-8 border border-secondary 
//                                 p-8 w-full dark:border-dark-border 
//                                 dark:bg-dark-box dark:text-dark-text'>
//                     {isLoading ? <Loading /> :
//                         <div className="pdf-container" style={{ height: '80vh', width: '100%' }}>
//                             <object
//                                 data={pdf}
//                                 type="application/pdf"
//                                 width="100%"
//                                 height="100%"
//                             >
//                                 <embed
//                                     src={pdf}
//                                     type="application/pdf"
//                                     width="100%"
//                                     height="100%"
//                                 />
//                                 <p className="text-center mt-4">
//                                     Bu PDF brauzer tarapyndan görkezilip bilinmedi.
//                                     <a href={pdf} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">
//                                         PDF-ni başga sahypada açyň.
//                                     </a>
//                                 </p>
//                             </object>
//                         </div>

//                     }
//                 </div>
//             </main>
//         </div>
//     )
// }

// export default LawsTable
